import { apiService } from './api';
import { type LegalRelease } from './legalDocuments';

// This is a temporary handoff of an explicit signup confirmation, never an
// authoritative accepted flag. Only the authenticated backend creates evidence.
const storageKey = 'simplysend.signup-legal-confirmation';

export function clearSignupLegalConfirmation() {
  try { sessionStorage.removeItem(storageKey); } catch { /* Storage may be unavailable; authenticated review remains available. */ }
}

export async function rememberSignupLegalConfirmation(release: LegalRelease, email: string) {
  try {
    sessionStorage.setItem(storageKey, JSON.stringify({ bundleId: release.bundleId, email: email.trim().toLowerCase(), expiresAt: new Date(Date.now() + 86400000).toISOString() }));
  } catch {
    // A browser storage restriction must not prevent account creation.
    clearSignupLegalConfirmation();
  }
}

export async function completeSignupLegalConfirmation(userId: string, email: string, workspaceId: string, role: string) {
  const raw = sessionStorage.getItem(storageKey);
  if (!raw) return;
  let pending;
  try { pending = JSON.parse(raw); } catch { sessionStorage.removeItem(storageKey); return; }
  if (!pending || typeof pending.email !== 'string' || typeof pending.expiresAt !== 'string') { clearSignupLegalConfirmation(); return; }
  // Never apply a pre-authentication confirmation to a joined workspace or to
  // a different account. A stale confirmation requires a fresh portal review.
  if (Date.parse(pending.expiresAt) <= Date.now() || !Number.isFinite(Date.parse(pending.expiresAt)) || (pending.email && pending.email !== email.toLowerCase())) {
    sessionStorage.removeItem(storageKey); return;
  }
  if (workspaceId !== userId || role !== 'owner') { sessionStorage.removeItem(storageKey); return; }
  await apiService.makeRequest('/account/legal/accept', {
    method: 'POST',
    body: JSON.stringify({ bundleId: pending.bundleId, agreed: true, source: 'signup_confirmation', acknowledgements: { noColdemail: true, ownedBrands: true, transactional: true } }),
  }, workspaceId);
  sessionStorage.removeItem(storageKey);
}
